var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(("Error" + _vm.errorId),{tag:"component",attrs:{"from-route":_vm.fromRoute}})}
var staticRenderFns = []

export { render, staticRenderFns }